module.exports = __webpack_public_path__ + "static/media/menu-requerimientos.10f89d38.svg";